import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { calcTimeDelta } from 'react-countdown';
import "./CourseCountdown.css"

const pad = (value) => String(value).padStart(2, '0');

const CourseCountdown = ({ eventDate }) => {

    const [countDownOver, setCountDownOver] = useState(false);

    useEffect(() => {
        let timeDelta = calcTimeDelta(eventDate)
        if (timeDelta.completed){
            setCountDownOver(true)
        }
    }, [eventDate])

    const renderer = ({ days, hours, minutes, completed }) => {
        if (completed) {
            return <p>L&apos;evento comincerà a momenti</p>
        }
        return (
            <div className="countdown-units" aria-live="polite">
                <div className="countdown-unit">
                    <span className="countdown-unit__value">{days}</span>
                    <span className="countdown-unit__label">{days === 1 ? 'giorno' : 'giorni'}</span>
                </div>
                <div className="countdown-unit">
                    <span className="countdown-unit__value">{pad(hours)}</span>
                    <span className="countdown-unit__label">ore</span>
                </div>
                <div className="countdown-unit">
                    <span className="countdown-unit__value">{pad(minutes)}</span>
                    <span className="countdown-unit__label">minuti</span>
                </div>
            </div>
        );
    };

    if (countDownOver) {
        return (
            <div className="course-countdown countdown-container">
                <p>L&apos;evento comincerà a momenti</p>
            </div>
        );
    }

    return (
        <div className="course-countdown countdown-container">
            <p>Inizio previsto dell&apos;evento tra</p>
            <Countdown date={eventDate} onComplete={() => setCountDownOver(true)} renderer={renderer} />
            <p>Puoi attendere qui l&apos;inizio</p>
        </div>
    );
};

export default CourseCountdown;
